<div class="container-fluid p-0">
    <app-header></app-header>
    <div class="row m-0 g-0">
      <div class="col-md-3 p-0">
        <app-folders></app-folders>
      </div>
  
      <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important;  margin-left: -7px;">
        <div class="card" style="height: 1000px;">
          <div class="card-body">
            <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
              <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
            </div>
           
  <!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
    </div>
    </div>


  


      <!-- Render Study Completion / Termination Record -->
<div *ngIf="formName === 'study-completion-termination-record'" class="card mt-4">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="m-0">Study Completion / Termination Record</h5>
     <button type="button" class="btn custom-button" (click)="dynamicFormRef.openCreateFieldModal()">+ Create Field</button>
  </div>

  <app-dynamic-form
    #dynamicFormRef
    [formConfig]="[ { folders: [formConfig[0].folders[0]] } ]"
    [studyName]="studyName"
    [folderName]="folderName"
    [formName]="formName">
  </app-dynamic-form>
</div>

<!-- Render Reason for Discontinuation -->
<div *ngIf="formName === 'reason-for-discontinuation'" class="card mt-4">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5 class="m-0">Reason for Discontinuation</h5>
    <!-- Create Field button triggers child's method -->
    <button type="button" class="btn custom-button" (click)="dynamicFormRef.openCreateFieldModal()">+ Create Field</button>
  </div>

   <app-dynamic-form
    #dynamicFormRef
    [formConfig]="[ { folders: [formConfig[0].folders[1]] } ]"
    [studyName]="studyName"
    [folderName]="folderName"
    [formName]="formName">
  </app-dynamic-form>
</div>
